import { useTranslation } from 'react-i18next'
import { InformationCircleIcon } from '@heroicons/react/24/outline'

const STYLES = {
  limited: 'bg-amber-100 text-amber-800 hover:bg-amber-200',
  possibly_affected: 'bg-sky-100 text-sky-800 hover:bg-sky-200',
}

/**
 * VH-221: labels a marker the user's own records explain. Renders nothing
 * for a fully interpretable marker, so unaffected tests look as before.
 */
export default function InterpretabilityBadge({ interpretability, onClick }) {
  const { t } = useTranslation()
  if (!STYLES[interpretability]) return null
  const label = t(`bloodTests.context.interpretability.${interpretability}`)
  return (
    <button
      type="button"
      onClick={onClick}
      className={`self-start inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-medium ${STYLES[interpretability]}`}
      aria-label={t('bloodTests.context.openDetails', { label })}
    >
      <InformationCircleIcon className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </button>
  )
}
